var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6849 6.95589L2.76401 0.777231C2.47072 0.604632 2.10653 0.633388 1.83147 0.633388C0.731265 0.633388 0.736145 1.47302 0.736145 1.68574V14.3142C0.736145 14.4941 0.731329 15.3667 1.83147 15.3667C2.10653 15.3667 2.47078 15.3953 2.76401 15.2227L12.6848 9.04416C13.4991 8.56521 13.3584 7.99999 13.3584 7.99999C13.3584 7.99999 13.4992 7.43477 12.6849 6.95589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.35a907b2fe7e476edb0aaccf2c6cc511.svg";
export { ForwardRef as ReactComponent };